import React from 'react';
import { graphql, Link } from 'gatsby';
import styled from 'styled-components';
import SEO from '../components/seo';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {INLINES} from '@contentful/rich-text-types';

import useWindowSize from '../hooks/useWindowSize';
import Img from 'gatsby-image';
import Layout from '../components/layout';
import AsideBlogSection from '../components/asideBlogSection';

import ArrowIcon from '../../static/images/arrow-fa.svg'
import FacebookIcon from '../../static/images/fb-icon.svg'
import LinkedinIcon from '../../static/images/linkedin-icon.svg'
import EmailIcon from '../../static/images/email-icon.svg'
import OhCleoLogo from '../../static/images/shareable.jpg'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
} from "react-share";

export const query = graphql`
  query ($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      publishedDate(formatString: "MMMM Do, YYYY")
      featuredImage {
        fluid(maxWidth: 2000, resizingBehavior: FILL) {
          ...GatsbyContentfulFluid 
        }
      }
      body {
        json
      }
      keywords
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 7.5rem 10.6rem;
  position: relative;
  background: var(--third-color);

   li {
    list-style-type: disc;
    color:  var(--light-700);
    margin-left: 16px;
  }
  i {
    font-style: italic;
    font-family: 'DM Sans Italic';
  }

  h2, h3, h4, h5, h6, a {
    color: var(--light-color);
   }

  h2 {
    padding: 8px 0 8px;
    margin-bottom: 24px;
    font: var(--font-headline-3);
  }
  
  >:nth-child(2) {
      width: 100%;
      display: flex;
      flex-direction: column; 
      position: relative;
      justify-content: center;

  }

  >:nth-child(3) {
    display: inherit;
    flex-direction: row;
  }

   .posted-on {
      font: var(--font-bodytext-2);
      color: var(--light-800);
      padding: 0 0 4px;
      position: relative;
      margin-left: 18%;
 
  }

  p {
    color: var(--light-700);
  }

  .featured {
    max-height: 600px;
    border-radius: 2px;
    margin-bottom: 60px;
    position: relative;
    top: -0.2%;
    width: 100%;
    max-width: 100%;
    display: inherit;
    align-self: center;
  }
  @media screen and (min-width: 1630px) and (max-width: 1859px) {
    .posted-on {
      left: -1%;
    }
  }
  @media screen and (min-width: 1860px) {
    .posted-on {
      margin-left: 17%;
    }
    
  }
  @media screen and (max-width: 1300px) {
    padding-left: 40px;
    padding-right: 40px;
    .posted-on {
      margin-left: 18%;
    }
  }
 @media screen and (min-width: 1001px) and (max-width: 1100px) {
   .posted-on {
     left: 3%;
   }
 }

  @media screen and (max-width: 1000px) {
    .posted-on {
      margin-left: 13%;
    }

  }
  @media screen and (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
   .posted-on {
     margin-left: 4%;
   }
    >:nth-child(3) {
      flex-direction: column-reverse;
    }
  }
  @media screen and (max-width: 550px ) {
    .posted-on {
      margin-left: 4%;
    }
  }
`;

const Content = styled.div`
  width: 60%;
  margin: auto;
  position: relative;
  padding: 0 50px;

   ul {
    list-style-type: disc;
    padding-left: 16px;
  }
   li {
    list-style-type: disc;
  }
  h4 {
    padding: 4px 0px 4px;
  }

  p {
    margin-bottom: 20px;
  }
  a  {
    text-decoration: none;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    padding: unset;
  }
 
`;
const ShareSocial = styled.div `
  display: flex;
  flex-direction: column;
 

  .button-1 {
    color: var(--light-color);
    padding: 8px 0 16px;
  }

  .share-buttons {
    display: inherit;
    flex-direction: row;

  }
  
  img {
   padding: 10px;
   margin: 8px 0 8px;
   border: 1px solid var(--light-400);
   border-radius: 15%;
   height: 15px;
   width: 15px;
   margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .share-buttons {
  flex-direction: column;
  }
  img { 
    margin-right: 0;
  }
}

@media screen and (max-width: 768px) {
 align-items: center;
 position: relative;
 top: -2%;
 margin-top: 10px;
    span:not(.share-buttons) {
      padding: 16px;
    }
    .share-buttons {
      flex-direction: row;
      img {
       margin: 0px 8px 0px;
      }
    }
  }
}
`
const ArrowsWrapper = styled.div `
  
  display: flex;
  justify-content: space-between;
  padding: 10%;

  .prev, .next {
  text-decoration: none;
  font: var(--font-bodytext-1);
  color: var(--light-400);
  position: relative;

  & span {
    opacity: 0.4;
    margin: 0 4px;
  }
}

.prev img {
  transform: rotate(180deg);
}

`;

const BlogPost = ({...props}) => {
  const { isTablet } = useWindowSize();


  const options = {
    renderNode: {
      'embedded-asset-block': node => {
        const alt = node.data.target.fields.title['en-US'];
        const { url } = node.data.target.fields.file['en-US'];
        return <img alt={alt} src={url} />;
      },
      [INLINES.HYPERLINK]: ({ data }, children) => (
        <a
            href={data.uri}
            target={`'_blank'`}
            rel={`${data.uri.startsWith(website_url) ? '' : 'noopener noreferrer'}`}
        >{children}
        </a>
    ),
    },
    
  };
  const website_url = 'https://ohcleo.com'
//checks if publishedDate is in the future comparing to current day
  const prev = props.pageContext.prev && new Date(props.pageContext.prev.node.publishedDate) <= new Date() ?  {
    url: `/blog/${props.pageContext.prev.node.slug}`
  } : null 

  const next = props.pageContext.next ? {
    url: `/blog/${props.pageContext.next.node.slug}`
  } : null

  const urlPost = `https://ohcleo.com${props.path}`
  const postDescription = props.data.contentfulBlogPost.body.json.content[0].content[0].value
  const postTitle = props.data.contentfulBlogPost.title
  const keywords = props.data.contentfulBlogPost.keywords

  return (
    <Layout showDarkStyling={true}>
      <SEO
        title={postTitle}
        description={postDescription}
        url={urlPost}
        image={props.data.contentfulBlogPost.featuredImage?.fluid?.src}
        type="article"
        keywords={keywords || "audio erotica, sex"}/>
      <Wrapper>
        {props.data.contentfulBlogPost.featuredImage && props.data.contentfulBlogPost.featuredImage.fluid ? (
            <Img
              className="featured"
              fluid={props.data.contentfulBlogPost.featuredImage.fluid}
              alt={postTitle}
            />
        ) : (
          <img style={{width: "600px", display: "flex", alignSelf: "center"}}
          src={OhCleoLogo}
          alt="OhCleo Logo"
        />
        )}
         {props.data.contentfulBlogPost.publishedDate && (
          <p className="posted-on">Posted on {props.data.contentfulBlogPost.publishedDate}</p>
        )}
      <div className="blogpost-content-wrapper">
        { isTablet ? <AsideBlogSection></AsideBlogSection> : <div></div>}
        <ShareSocial>
            <span className="button-1">Share</span>
            <span className="share-buttons">
              <FacebookShareButton
                url={urlPost}
                quote={`Check out the post at OhCleo! \"${postTitle}\"`}>
                <img src={FacebookIcon} />
              </FacebookShareButton>
              <LinkedinShareButton
                url={urlPost}
                title={`\"${postTitle}\"`}
                summary={postDescription}>
                <img src={LinkedinIcon} />
              </LinkedinShareButton>
              <EmailShareButton
                url={urlPost}
                subject={`Check out the post at OhCleo.com \" ${postTitle} \"`}
              >
                <img src={EmailIcon}/>
              </EmailShareButton>
              </span>
        </ShareSocial>
        <Content>
          <h2>{postTitle}</h2>
          {documentToReactComponents(
            props.data.contentfulBlogPost.body.json,
            options,
          )}
        </Content>
        { !isTablet ? <AsideBlogSection></AsideBlogSection> : <div></div>}

      </div>
        <ArrowsWrapper>
          {prev ? (<div><Link className="prev" to={prev.url}><span><img src={ArrowIcon}/></span>Prev</Link></div>) : (<div style={{visibility: 'hidden'}}></div>)}
          {next && (<div><Link className="next" to={next.url}>Next<span><img src={ArrowIcon}/></span></Link></div>)}
        </ArrowsWrapper>
      </Wrapper>
    </Layout>
   
  );
};

export default BlogPost;
